import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useContext, useState, useRef, useEffect, createContext } from 'react';
import { rules, isRequired, isEmail, Form } from '@awardit/formaggio';
import { useHistory } from 'react-router-dom';
import { useSendMessage } from 'crustate/react';
import { addMessage } from '@crossroads/shop-state/messages';
import { useTranslate } from '@awardit/react-use-translate';
import { focusInvalidField } from '../../helpers/utils.js';
import { Wrapper, Foldable, Button } from '@crossroads/ui-components';
import { CheckboxField, Field } from '../Field/index.js';
import styles from 'shop-views/PriceLock.scss';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var validation = rules([isRequired("email"), isEmail("email"), isRequired("firstName"), isRequired("lastName")]);

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var getDocumentBody = () => {
  var body = typeof window === "object" && window && window.document && window.document.body;
  return body || null;
};

var ElementContext = /*#__PURE__*/createContext(getDocumentBody());
var PriceLock = _ref => {
  var subscribeToNewsletter = _ref.subscribeToNewsletter,
      useClient = _ref.useClient,
      isOpen = _ref.isOpen,
      closeModal = _ref.closeModal,
      images = _ref.images;
  var rootEl = useContext(ElementContext);
  var client = useClient();

  var _useHistory = useHistory(),
      location = _useHistory.location,
      replace = _useHistory.replace;

  var sendMessage = useSendMessage();
  var t = useTranslate();

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var inputRef = useRef(null);

  var _useState2 = useState({
    email: "",
    firstName: "",
    lastName: "",
    approvedTerms: false
  }),
      state = _useState2[0],
      setState = _useState2[1];

  var errors = validation(state);
  useEffect(() => {
    if (rootEl) {
      if (isOpen) {
        rootEl.style.overflow = "hidden";
      } else {
        rootEl.style.overflow = "auto";
      }
    }

    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen, rootEl]);

  var close = submitted => {
    setState({
      email: "",
      firstName: "",
      lastName: "",
      approvedTerms: false
    });
    setLoading(false);
    closeModal(submitted);
  };

  var submit = _async(function (e) {
    e.preventDefault();
    setLoading(true);
    var allowedResult = ["success", "notModified"];
    return _await(client(subscribeToNewsletter, {
      email: state.email,
      firstName: state.firstName,
      lastName: state.lastName
    }), function (result) {
      if (allowedResult.includes(result.subscribeToNewsletter.result)) {
        var searchParams = location.search + "&subscribed=true";
        replace({
          pathname: location.pathname,
          search: searchParams
        });
        close("true");
      } else {
        sendMessage(addMessage("NEWSLETTER.ERROR." + result.subscribeToNewsletter.result, "error"));
        close("false");
      }
    });
  });

  return isOpen ? /*#__PURE__*/React.createElement("div", {
    className: styles.block
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.contentBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.overlay,
    onClick: () => close("false")
  }), /*#__PURE__*/React.createElement(Wrapper, {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("h3", null, t("PRICE_LOCK.HEADER"))), images && images.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles.images
  }, images.map(image => /*#__PURE__*/React.createElement("img", {
    key: image.title,
    src: image.src,
    alt: image.title
  }))), /*#__PURE__*/React.createElement(Form, {
    className: styles.form,
    autoComplete: "on",
    value: state,
    errors: errors,
    onError: focusInvalidField,
    onChange: x => {
      setState(_extends({}, state, x));
    },
    onSubmit: submit
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.fields
  }, /*#__PURE__*/React.createElement(CheckboxField, {
    ref: inputRef,
    className: styles.checkbox,
    name: "approvedTerms",
    checked: state.approvedTerms
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.checkboxText,
    dangerouslySetInnerHTML: {
      __html: t("PRICE_LOCK.TERMS_TEXT")
    }
  })), /*#__PURE__*/React.createElement(Foldable, {
    className: styles.inputs,
    open: state.approvedTerms
  }, /*#__PURE__*/React.createElement(Field, {
    disabled: loading,
    type: "email",
    name: "email",
    autoComplete: "email",
    label: t("ADDRESS.EMAIL"),
    placeholder: t("ADDRESS.EMAIL")
  }), /*#__PURE__*/React.createElement(Field, {
    disabled: loading,
    type: "text",
    name: "firstName",
    autoComplete: "firstName",
    label: t("ADDRESS.FIRSTNAME"),
    placeholder: t("ADDRESS.FIRSTNAME")
  }), /*#__PURE__*/React.createElement(Field, {
    disabled: loading,
    type: "text",
    name: "lastName",
    autoComplete: "lastName",
    label: t("ADDRESS.LASTNAME"),
    placeholder: t("ADDRESS.LASTNAME")
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.buttons
  }, state.approvedTerms && /*#__PURE__*/React.createElement(Button, {
    loading: loading,
    type: "submit",
    variant: "primary"
  }, t("PRICE_LOCK.SEND")), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: () => close("false")
  }, t("PRICE_LOCK.CLOSE"))))))) : null;
};

export { ElementContext, PriceLock };
//# sourceMappingURL=index.js.map
